export default {
  //授课首页
  SKcourseList:'',
  SKevaluateType:'',
}
